export const RESET_GENERAL_STATE = 'RESET_GENERAL_STATE'
export const ADD_PAYWALL = `ADD_PAYWALL`
export const SET_IS_PAID_USER = `SET_IS_PAID_USER`
export const SET_GENERAL_CONFIG = 'SET_GENERAL_CONFIG'
export const SET_IS_POPOVER_CHAT_OPEN = 'SET_IS_POPOVER_CHAT_OPEN'
export const DEFAULT_OPEN_POPOVER_CHAT = 'DEFAULT_OPEN_POPOVER_CHAT'
export const OPEN_POPOVER_ON_CLICKTRHOUGH = 'OPEN_POPOVER_ON_CLICKTRHOUGH'
export const SET_SHOW_SEND_CHAT_MODAL = 'SET_SHOW_SEND_CHAT_MODAL'
